
import consumablesList_weixiu from './list.vue'
import recordInfo_weixiu from './info.vue'



let a = Object.assign({ consumablesList_weixiu,recordInfo_weixiu})
export default a
